var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('TaskHeader')],1),_c('v-col',{attrs:{"cols":"12"}},[(_vm.id == 'list')?_c('Tasks'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }